import React, { useState } from "react";
import { Loader } from "lucide-react";
import ToastMessage from "../reuseable/ToastMessage";
import useUserManagement from "../../hooks/useUserManagement.js";

const UserRegistrations = () => {
  const { createUser } = useUserManagement();

  const [email, setEmail] = useState("");
  const [role, setUserType] = useState("Member");
  const [isLoading, setIsLoading] = useState(false);
  const [toast, setToast] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const payload = {
      email,
      role,
    };

    try {
      await createUser(payload);

      setToast({ type: "success", message: "✅ User registered successfully!" });
      setTimeout(() => setToast(null), 3000);

      setEmail("");
      setUserType("Member");
    } catch (error) {
      console.error("User register error:", error);
      const errorMsg = error.response?.data?.message || "User registration failed";
      setToast({ type: "error", message: `❌ ${errorMsg}` });
      setTimeout(() => setToast(null), 3000);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
        padding: 32,
        margin: "0 auto",
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          gap: 24,
          alignItems: "center",
          marginBottom: 24,
          flexWrap: "wrap",
        }}
      >
        <div style={{ flex: 1 }}>
          <label style={{ fontWeight: 500, marginBottom: 8, display: "block" }}>
            Email *
          </label>
          <input
            type="email"
            placeholder="Email Address"
            required
            disabled={isLoading}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              width: "100%",
              padding: 10,
              borderRadius: 4,
              border: "1px solid #ccc",
              fontSize: 16,
              height: 48,
              backgroundColor: isLoading ? "#f0f0f0" : "white",
              cursor: isLoading ? "not-allowed" : "auto",
            }}
          />
        </div>

        <div style={{ flex: 1 }}>
          <label style={{ fontWeight: 500, marginBottom: 8, display: "block" }}>
            User Type *
          </label>
          <select
            value={role}
            disabled={isLoading}
            onChange={(e) => setUserType(e.target.value)}
            style={{
              width: "100%",
              padding: 10,
              borderRadius: 4,
              border: "1px solid #ccc",
              fontSize: 16,
              height: 48,
              backgroundColor: isLoading ? "#f0f0f0" : "white",
              cursor: isLoading ? "not-allowed" : "auto",
            }}
          >
            <option value="Member">Member</option>
            <option value="Admin">Admin</option>
          </select>
        </div>

        <div style={{ display: "flex", gap: 16, width: "100%" }}>
          <button
            type="reset"
            disabled={isLoading}
            onClick={() => {
              setEmail("");
              setUserType("Member");
            }}
            style={{
              background: isLoading ? "#f5f5f5" : "#ffffff",
              color: isLoading ? "#ccc" : "#bb1ccc",
              border: isLoading ? "1px solid #e0e0e0" : "1px solid #bb1ccc",
              borderRadius: 4,
              padding: "8px 32px",
              fontWeight: 600,
              fontSize: 16,
              cursor: isLoading ? "not-allowed" : "pointer",
              transition: "all 0.3s ease",
            }}
          >
            Reset
          </button>

          <button
            type="submit"
            disabled={isLoading}
            style={{
              background: isLoading ? "#d4a5e6" : "#bb1ccc",
              color: "#fff",
              border: "none",
              borderRadius: 4,
              padding: "8px 32px",
              fontWeight: 600,
              fontSize: 16,
              cursor: isLoading ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              transition: "all 0.3s ease",
            }}
          >
            {isLoading && <Loader size={16} className="animate-spin" />}
            {isLoading ? "Registering..." : "Register"}
          </button>
        </div>
      </form>

      <ToastMessage toast={toast} />

      <style>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        .animate-spin {
          animation: spin 1s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default UserRegistrations;